import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Link from 'next/link';
import Button from '@seaweb/coral/components/Button';

const StyledButton = styled(Button)`
  outline: none;

  a {
    color: inherit !important;
  }
`;

function LinkButton(props) {
  const { href, ...restProps } = props;

  return (
    <Link href={href}>
      <StyledButton {...restProps}>{restProps.children}</StyledButton>
    </Link>
  );
}

LinkButton.propTypes = {
  href: PropTypes.string.isRequired,
};

export default LinkButton;
